module.exports = __webpack_public_path__ + "img/scifi.d7362953.jpg";